<template>
  <div id="fee_detail">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $route.query.statuteId != undefined ? '編輯':'新增' }}規約
          </div>
        </div>
        <div class="right">
          <span class="tips">*為必填</span>
        </div>
      </div>
      <div class="blockWrap">
        <el-form
          ref="ruleData"
          status-icon
          label-position="left"
          class="list"
          :model="ruleData"
          :rules="validation"
        >
          <el-form-item
            label="標題"
            prop="title"
            :show-message="false"
          >
            <el-input
              v-model="ruleData.title"
              size="medium"
              placeholder="請輸入標題"
              maxlength="50"
            />
            <template><span>限 50 個字元</span></template>
          </el-form-item>
          <el-form-item
            label="類型"
            prop="type"
            :show-message="false"
          >
            <el-select
              v-model="ruleData.type"
              placeholder="請選擇"
              size="small"
            >
              <el-option
                v-for="item in typeList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="附加檔案"
            prop="files"
          >
            <template>
              <file
                type="file"
                name="file"
                :filearray="ruleData.files"
                :quantity="fileMaxNumber"
                @on-fileArray-change="changeFiles"
              />
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottomControl">
        <el-button
          round
          @click="$router.push({name:'Rules'})"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          :disabled="isDisable"
          round
          @click="subRuleData"
        >
          儲存
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import file from '@/components/File'
const checkFile = (rule, value, callback) => {
  console.log('value', value)
  const file = document.querySelectorAll('.file-wrap .file')
  if (value.length === 0) {
    console.log('no file')
    for (let i = 0; i < file.length; i++) {
      file[i].classList.add('error')
    }
    return callback(new Error(' '))
  }
  console.log('file.length', file.length)
  for (let i = 0; i < file.length; i++) {
    file[i].classList.remove('error')
    // file[i].classList.add('success');
  }
  callback()
}
const checkTitle = (rule, value, callback) => {
  console.log('value', value)
  if (value.length === 0) {
    return callback(new Error(' '))
  }
  if (!value.trim()) {
    return callback(new Error(' '))
  }
  callback()
}
export default {
  components: {
    file
  },
  data () {
    return {
      authorization: '',
      ruleData: {
        id: '',
        title: '',
        type: '',
        files: []
      },
      validation: {
        title:
          [
            { required: true, message: '', trigger: 'blur', validator: checkTitle },
            { min: 0, max: 50, message: '', trigger: 'blur' }
          ],
        type:
          [
            { required: true, message: '', trigger: 'change' }
          ],
        files:
          [
            { required: true, validator: checkFile, trigger: 'change' }
          ]
      },
      typeList: [],
      fileMaxNumber: 5,
      isDisable: false,
      updateNotify: false
    }
  },
  watch: {
  },
  mounted () {
    this.authorization = this.$getCookie('comLoginToken').replace('token=', '')
    this.getTypeList()
    // eslint-disable-next-line eqeqeq
    if (this.$route.query.statuteId != undefined) {
      this.getRuleData()
    }
  },
  methods: {
    changeFiles (val) {
      this.ruleData.files = val
      console.log(this.ruleData.files)
      this.$refs.ruleData.validateField('files')
    },
    getRuleData () {
      axios(`${process.env.VUE_APP_MAPI_URL}/Statute/Info`, {
        method: 'GET',
        headers: { Authorization: this.authorization },
        params: { Id: this.$route.query.statuteId }
      }).then(res => {
        const resData = res.data.Data
        console.log(resData)
        const typeData = this.typeList.find(item => {
          return item.Name === resData.TypeName
        })
        this.ruleData = {
          id: resData.StatuteId,
          title: resData.Title,
          type: typeData.Value,
          files: []
        }
        resData.Attached.forEach(item => {
          this.ruleData.files.push({
            type: 'file',
            file: '',
            uploadUrl: item.url,
            fileName: item.fileName
          })
        })
        // this.$refs.ruleData.clearValidate('type');
        this.$refs.ruleData.resetFields()
        console.log(this.ruleData)
      }).catch(err => {
        console.log(err)
      })
    },
    getTypeList () {
      axios(`${process.env.VUE_APP_MAPI_URL}/CustomType/List`, {
        method: 'GET',
        headers: { Authorization: this.authorization },
        params: { CustomType: 'StatuteType' }
      }).then(res => {
        this.typeList = res.data.Data.List
        console.log(this.typeList)
      }).catch(err => {
        console.log(err.response)
      })
    },

    // 送出按鈕
    subRuleData () {
      this.isDisable = true
      this.$refs.ruleData.validate((valid) => {
        if (valid) {
          // eslint-disable-next-line eqeqeq
          if (this.$route.query.statuteId != undefined) {
            this.$confirm('此則規約辦法已更新，是否發送App通知住戶？', '提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              // roundButton: true,
              type: 'warning',
              closeOnClickModal: false
            }).then(() => {
              console.log('notify yes')
              this.updateNotify = true
              this.saveRule()
            }).catch(() => {
              console.log('notify no')
              this.saveRule()
            })
          } else {
            this.saveRule()
          }
        } else {
          window.scrollTo(0, 0)
        }
      })
      setTimeout(() => {
        this.isDisable = false
      }, 1000)
    },

    // 儲存資料與畫面紀錄
    saveRule () {
      const vobj = this
      const totalCount = {
        file: vobj.ruleData.files.length
      }
      const uploadStatus = {
        file: {
          success: 0,
          error: 0
        }
      }
      const loadingWrap = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // eslint-disable-next-line eqeqeq
      if (totalCount.file == 0) {
        document.querySelector('.el-loading-text').innerHTML = '正在寫入資料中請稍後'
      } else {
        document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.file.success + uploadStatus.file.error}筆，共${totalCount.img + totalCount.file}筆`
      }

      upload_file()

      // 上傳檔案
      function upload_file () {
        // eslint-disable-next-line eqeqeq
        if (vobj.ruleData.files.length != 0) {
          document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.file.success + uploadStatus.file.error}筆，共${totalCount.file}筆`
          const now_index = uploadStatus.file.success + uploadStatus.file.error

          // eslint-disable-next-line eqeqeq
          if (vobj.ruleData.files[now_index].file == '') {
            uploadStatus.file.success += 1
            next()
          } else {
            sendFileUploadApi(vobj.ruleData.files[now_index].file, res => {
              // eslint-disable-next-line eqeqeq
              if (res != 'error') {
                vobj.ruleData.files[now_index].uploadUrl = res.data.Data.Url
                uploadStatus.file.success += 1
                next()
              }
            })
          }

          function next () {
            document.querySelector('.el-loading-text').innerHTML = `檔案已上傳${uploadStatus.file.success + uploadStatus.file.error}筆，共${totalCount.file}筆`
            // eslint-disable-next-line eqeqeq
            if (totalCount.file == uploadStatus.file.success + uploadStatus.file.error) {
              document.querySelector('.el-loading-text').innerHTML = '正在寫入資料中請稍後...'
              sendSaveRuleApi()
            } else {
              upload_file()
            }
          }
        } else {
          sendSaveRuleApi()
        }
      }

      // 處理儲存規約資料API
      function sendSaveRuleApi () {
        // eslint-disable-next-line eqeqeq
        const url = vobj.$route.query.statuteId == undefined ? `${process.env.VUE_APP_MAPI_URL}/Statute/Create` : `${process.env.VUE_APP_MAPI_URL}/Statute/Update`
        const Data = {
          Name: vobj.ruleData.title,
          TypeId: vobj.ruleData.type,
          Attached: []
        }

        // eslint-disable-next-line eqeqeq
        if (vobj.$route.query.statuteId != undefined) {
          Data.Id = vobj.ruleData.id
        }

        console.log(Data)
        vobj.ruleData.files.forEach(val => {
          console.log(val)
          Data.Attached.push({
            fileName: val.uploadUrl.split('/')[val.uploadUrl.split('/').length - 1],
            url: val.uploadUrl
          })
        })

        console.log(Data)
        axios(url, {
          // eslint-disable-next-line eqeqeq
          method: vobj.$route.query.statuteId == undefined ? 'POST' : 'PUT',
          data: Data,
          headers: { Authorization: vobj.authorization }
        }).then(res => {
          loadingWrap.close()
          console.log('vobj.updateNotify', vobj.updateNotify)
          if (vobj.updateNotify) {
            const notifyFormData = new FormData()
            notifyFormData.append('StatuteId', vobj.ruleData.id)
            axios(`${process.env.VUE_APP_MAPI_URL}/Statute/NewStatuteNotify`, {
              method: 'PUT',
              headers: { Authorization: vobj.authorization },
              data: notifyFormData
            }).then(res => {
              vobj.$alert('規約更新完成，且發送推播成功。', '', {
                confirmButtonText: '確定',
                callback: action => {
                  vobj.$store.commit('recordRulesHeight', null)
                  vobj.$router.push({ name: 'Rules' })
                }
              })
            }).catch(() => {
              vobj.$alert('規約更新完成，但發送推播失敗。', '', {
                confirmButtonText: '確定',
                callback: action => {}
              })
            })
          } else {
            // eslint-disable-next-line eqeqeq
            vobj.$alert(`規約${vobj.$route.query.statuteId == undefined ? '新增' : '更新'}完成。`, '', {
              confirmButtonText: '確定',
              callback: action => {
                vobj.$store.commit('recordRulesHeight', null)
                vobj.$router.push({ name: 'Rules' })
              }
            })
          }
        }).catch(err => {
          loadingWrap.close()
          // eslint-disable-next-line eqeqeq
          vobj.$alert(`規約${vobj.$route.query.statuteId == undefined ? '新增' : '更新'}失敗，${err.response.data.ErrorMessage.Description}`, '', {
            confirmButtonText: '確定',
            callback: action => {
            }
          })
        })
      }

      // 處理檔案上傳API
      function sendFileUploadApi (FileData, callback) {
        const url = `${process.env.VUE_APP_MAPI_URL}/Statute/Upload`
        const uploadFormData = new FormData()
        uploadFormData.append('File', FileData)

        axios(url, {
          method: 'PUT',
          headers: { Authorization: vobj.authorization },
          data: uploadFormData
        }).then((res) => {
          callback(res)
        }).catch(err => {
          console.log(err.response)
          loadingWrap.close()
          if (err.response.data.ErrorMessage.Code === 400001) {
            vobj.$message({
              message: err.response.data.ErrorMessage.Description,
              type: 'warning'
            })
            callback('error')
            return
          }
          vobj.$message({
            message: '上傳過程發生異常，請重新上傳',
            type: 'warning'
          })
          callback('error')
        })
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#fee_detail
  padding: 50px 0
  ::v-deep .el-dialog
    +basicDialog
    p
      line-height: 25px
  .main
    min-width: 1140px
    max-width: 1140px
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        color: $mainFontColor
        text-align: left
      .tips
        color: #f00
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
  ::v-deep .el-form.list
    +basicFormInsert
    .el-form-item
      &.Interval
        width: 50%
        padding: 5px
      &.half
        width: 50%
      &__content
        flex: 1
        // max-width: 400px
        .file-wrap
          flex-wrap: wrap
        .el-select,.el-date-editor
          width: 100%
  .blockWrap
    text-align: left
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    margin-bottom: 30px
    padding: 0 240px 0 240px
    box-sizing: border-box
  .bottomControl
    text-align: center
    border-top: solid 1px $borderDark1
    padding: 30px 0 0
</style>
